import { render } from "./PromptList.vue?vue&type=template&id=72fbfef1"
import script from "./PromptList.vue?vue&type=script&lang=js"
export * from "./PromptList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__